// ********************************************************
// Language
// Handles stuff like current language and translations.
// Language format: ISO Language Code
// ********************************************************

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { app } from '@/main'
import * as Log from '@/core/logger'
import en from '../../public/lang/en.json'
import enFlag from '@/assets/img/flags/en.png'
import daFlag from '@/assets/img/flags/da.png'
import svFlag from '@/assets/img/flags/sv.png'
import nbFlag from '@/assets/img/flags/nb.png'
import moment from 'moment'
// import * as LocalStorage from '@/core/local-storage'
import { loadTranslations } from '@/core/translations'
import * as Security from '@/core/security'
// import Admin from '@/core/admin'
import { UserDetail } from '@/core/userDetail'
Vue.use(VueI18n)

// Default only 'en' is loaded. More will be loaded dynamically if needed.
const loadedTranslations = {
  en
}

const i18n = new VueI18n({
  locale: 'en',
  messages: loadedTranslations
})

var languageDetail

export async function detectDefaultLand () {
  // Load user's language
  await Security.autoLogin()
  let loadedLang = 'en'
  if (Security.user.loggedIn) {
    languageDetail = await UserDetail.load(Security.user.id, 'language')
    if (languageDetail) {
      loadedLang = languageDetail.Value
    }
  }
  // console.log('---------------------------> USER DETAIL LANGUAGE: ', languageDetail)

  const loadedLangValid = getSupportedLang().some(item => item.lang === loadedLang)

  if (loadedLang != null && loadedLangValid) {
    // console.log('---------------------------> LoadedLang: ', loadedLang)
    setLang(loadedLang)
  } else {
    // Use language from navigator
    let navigatorLang = navigator.language || navigator.userLanguage
    // console.log('--> Navigator language/userlanguage: ', navigator.language, navigator.userLanguage)
    navigatorLang = navigatorLang.slice(0, 2)
    if (navigatorLang === 'da' || navigatorLang === 'sv' || navigatorLang === 'nb') setLang(navigatorLang)
    else setLang('en')
  }
}

export function getSupportedLang () {
  return [
    { lang: 'en', flag: enFlag },
    { lang: 'da', flag: daFlag },
    { lang: 'sv', flag: svFlag },
    { lang: 'nb', flag: nbFlag }
  ]
}

export function getCurrentFlag () {
  // If app is not initialized yet, we return 'en'
  if (app === undefined) return enFlag

  if (app.$i18n.locale === 'da') return daFlag
  else if (app.$i18n.locale === 'sv') return svFlag
  else if (app.$i18n.locale === 'nb') return nbFlag
  else return enFlag
}

export function getCurrentLang () {
  return app.$i18n.locale
}

export async function setLang (lang) {
  loadTranslation(lang).then(async (translation) => {
    if (Security.user.loggedIn) {
      // Filter out the custom translations not used by current lang
      const translations = await loadTranslations()
      translations.filter(t => {
        return t.LangCode === lang
        // And merge custom translations into stored translation file
      })
        .map(t => {
          translation[t.KeyText] = t.CustomText
        })
      languageDetail.Value = lang
      // Save this to database, so we remeber user's language
      if (languageDetail && languageDetail.UserId) {
        // console.log('--> Writing out obj from save lang: ', languageDetail)
        const saveRes = await languageDetail.save()
        if (saveRes.data) { // if we saved, then use the return value to set our object
          languageDetail = new UserDetail(saveRes.data)
        }
      }
    }

    Log.log('Language loaded: ', lang)
    app.$i18n.setLocaleMessage(lang, translation)
    app.$i18n.locale = lang
    moment.locale(lang) // Let's have date formats in this locale
    // If app exist, we might also have components that would like
    // to re-render according to locale.
    if (app != null) app.$emit('force-update')

    // LocalStorage.save('language', app.$i18n.locale)
  })
}

export function loadTranslation (lang) {
  return fetch(`/lang/${lang}.json`, {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((res) => {
    return res.json()
  }).then((json) => {
    if (Object.keys(json).length === 0) {
      throw new Error('No data for language "' + lang + '" was found in json file!')
    } else {
      return Promise.resolve(json)
    }
  })
}

export default i18n
